export const BANNER_MAX_SIZE = 5000000; // 5Mo

/** @typedef {'customAdvertising' | 'customBanner' | 'customLogo'} CustomizeParametersEnum */

/** @typedef {'ADVERTISING' | 'BANNER' | 'LOGO'} CustomizeTypesEnum */
export const CUSTOMIZE_TYPES = {
  ADVERTISING: 'ADVERTISING',
  BANNER: 'BANNER',
  LOGO: 'LOGO',
};
